import React, { useEffect, useMemo, useState } from "react";
import BaseInput from "../../BaseInput";
import { getImageBaseUrl } from "../../../services/s3-utils";
import QalortButton from "../../Button";
import Empty from "../../Empty";
import empty from "../../../assets/empty-cohort-play.svg";
import CohortCard from "./CohortCard";
import NavBar from "../../NavBar";
import EmptyCohort from "../EmptyCohort";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { LoadingOutlined } from "@ant-design/icons";
import { GetDraftCohorts } from "../../../services/cohortService";
import { useMyCohorts } from "../../../hooks/useMyCohorts";
import useEnableJoinBtn from "../../../hooks/useEnableJoinBtn";
import { Modal } from "antd";

function MyCohorts() {
  const [tabs, setTabs] = useState([
    "Upcoming",
    "Live",
    "Past",
    "Drafts",
    "Archived",
  ]);
  const { checkIfIsLive, checkIfIsUpcoming } = useEnableJoinBtn();
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const navigate = useNavigate();
  const [drafts, setDrafts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const qalortUser = useSelector((state) => state.user.userData);
  const {
    data: cohorts = [],
    isLoading: loading,
    refetch,
  } = useMyCohorts(qalortUser?.username || "");
  console.log(
    "cohorts",
    cohorts.filter((cohort) => cohort.slug === "introduction-to-python-26fed")
  );

  const [searchTerm, setSearchTerm] = useState("");

  const data = {
    Upcoming: cohorts.filter((item) => {
      return checkIfIsUpcoming(item);
    }),
    Live: cohorts.filter(
      (item) =>
        !dayjs(item.end_date).isBefore(dayjs(), "day") && checkIfIsLive(item)
    ),
    Past: cohorts.filter((c) => dayjs(c.end_date).isBefore(dayjs(), "minute")),
    Archived: cohorts.filter((c) => c.status === "archived"),
    Drafts: drafts || [],
  };

  const filteredData = useMemo(() => {
    const lowerCaseQuery = searchTerm.toLowerCase();
    return {
      Upcoming: data["Upcoming"].filter((cohort) =>
        cohort.title.toLowerCase().includes(lowerCaseQuery)
      ),
      Live: data["Live"].filter((cohort) =>
        cohort.title.toLowerCase().includes(lowerCaseQuery)
      ),
      Past: data["Past"].filter((cohort) =>
        cohort.title.toLowerCase().includes(lowerCaseQuery)
      ),
      Archived: data["Archived"]?.filter((cohort) =>
        cohort.title.toLowerCase().includes(lowerCaseQuery)
      ),
      Drafts: data["Drafts"]?.filter((cohort) =>
        cohort.title.toLowerCase().includes(lowerCaseQuery)
      ),
    };
  }, [searchTerm, data]);

  const fetchDrafts = async () => {
    try {
      const res = await GetDraftCohorts();
      setDrafts(res.data.data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchDrafts();
    if (qalortUser?.user_type !== "instructor") {
      setTabs(["Upcoming", "Live", "Past"]);
    }
  }, []);

  const renderContent = () => {
    const items = filteredData[activeTab];
    if (!cohorts.length) {
      return (
        <div className="flex flex-wrap gap-4 pb-16">
          <button
            onClick={() => setShowModal(true)}
            className={`bg-white rounded-lg border border-neutral w-full md:w-[270px] h-[300px] overflow-hidden flex justify-center items-center`}
          >
            <img src={empty} alt="" className="w-full" />
          </button>
          {qalortUser?.user_type === "instructor" && (
            <button
              onClick={() => navigate("/cohort/create-cohort")}
              className={`bg-white rounded-lg border-dashed border border-neutral w-full md:w-[270px] h-[300px] overflow-hidden flex justify-center items-center flex-col`}
            >
              <svg
                width="37"
                height="37"
                viewBox="0 0 37 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.4739 36.2216V0.596589H21.5194V36.2216H15.4739ZM0.684127 21.4318V15.3864H36.3091V21.4318H0.684127Z"
                  fill="#30307D"
                />
              </svg>

              <p className="mt-[12px] text-main font-semibold">
                Create Cohorts
              </p>
              <p className="-mt-2 mx-[35px] text-tint">
                Click here to setup a new Cohort
              </p>
            </button>
          )}
        </div>
      );
    } else if (items && items?.length > 0) {
      return (
        <div className="flex flex-wrap gap-4 pb-16">
          {items.map((item, i) => (
            <CohortCard
              key={i}
              title={item.title}
              description={item.description}
              date={item.start_date}
              cohort={item}
              price={item.price}
              currency={item.currency}
              linkPath={`cohort/viewcohort/${item.slug}`}
              isDraft={activeTab === "Drafts"}
              refreshList={
                activeTab === "Drafts" ? fetchDrafts : () => refetch()
              }
              isPast={activeTab === "Past"}
            />
          ))}
        </div>
      );
    } else {
      return (
        <Empty
          title={`You have no ${activeTab.toLowerCase()} cohorts`}
          imageClassName="w-[138px] h-[117px]"
        />
      );
    }
  };

  if (loading) {
    return (
      <div
        className="flex flex-col items-center justify-center h-screen"
        data-testid="app_loader"
      >
        <LoadingOutlined style={{ fontSize: "50px" }} />
      </div>
    );
  }

  return (
    <>
      <NavBar
        title="My Cohorts"
        className="lg:sticky"
        // description="Your Cohort description will show up here"
      />
      <div className="pt-[94px] lg:pt-0">
        <div className="border border-grey-2 pt-4 rounded-lg h-full md:min-h-[82vh] mb-5 lg:my-5 mx-0 md:mx-5 lg:ml-[47px] lg:mr-[58px] ">
          <div className="flex justify-between items-center border-b pb-[15px] border-grey-2 mb-5 flex-col [@media(min-width:950px)]:flex-row">
            <div className="flex pb-5 [@media(min-width:950px)]:pb-0 border-b border-grey-2 [@media(min-width:950px)]:border-0 [@media(max-width:950px)]:mb-4 lg:mb-0 [@media(max-width:1023px)]:justify-between [@media(max-width:950px)]:w-full [@media(max-width:950px)]:overflow-x-auto px-5 [@media(max-width:400px)]:pr-0">
              {tabs.map((tab, i) => (
                <button
                  key={i}
                  onClick={() => setActiveTab(tab)}
                  className="[@media(max-width:1023px)]:flex-shrink-0"
                >
                  <p
                    className={`py-2 px-4 font-medium p-sm mb-0 rounded-md ${
                      activeTab === tab ? "pri bg-pri-tint" : "text-tint"
                    }`}
                    key={i}
                  >
                    {tab}
                  </p>
                </button>
              ))}
            </div>
            <div className="flex gap-4 [@media(max-width:450px)]:gap-2 [@media(max-width:1023px)]:justify-between [@media(max-width:1023px)]:w-full [@media(max-width:1023px)]:items-center px-5">
              <BaseInput
                className="w-[270px] [@media(max-width:1023px)]:w-full"
                inputClassName="pl-10 !py-2.5 px-4 !leading-7"
                prefixClassName="top-4"
                icon={`${getImageBaseUrl}/assets/search.svg`}
                placeholder="Search Cohorts"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {qalortUser?.user_type === "instructor" && (
                <QalortButton
                  type="primary"
                  className="py-3 px-4 h-[unset] hidden lg:block"
                  onClick={() => navigate("/cohort/create-cohort")}
                >
                  + New Cohort
                </QalortButton>
              )}

              <button
                className="bg-pri rounded-full flex justify-center items-center w-12 h-12 lg:hidden flex-shrink-0"
                onClick={() => navigate("/cohort/create-cohort")}
              >
                <img src={`${getImageBaseUrl}/assets/add.svg`} alt="" />
              </button>
            </div>
          </div>
          <div className="p-5">{renderContent()}</div>
        </div>
      </div>

      <Modal
        open={showModal}
        onCancel={() => setShowModal(false)}
        className="p-0"
        footer={null}
        width={800}
      >
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/ED4_wNXBX7M?si=t4-v6sKOWChov2fs"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          className="w-full h-[530px]"
        ></iframe>
      </Modal>
    </>
  );
}

export default MyCohorts;
